import Axios from "axios";
import {
    URL_GET_STATISTIC_REPORT_PUB_PERFORMANCE
} from "../../config/DomainConfig"

const callGetStatisticReportPubPerformance = async (dateFrom, dateTo) => {
    const resp = await Axios.get(URL_GET_STATISTIC_REPORT_PUB_PERFORMANCE() + "/" + dateFrom + "/" + dateTo, { validateStatus: status => status < 500 })

    if (resp && resp.status === 400) {
        return { error: resp.data, pubPerformanceEntities: [] }
    }

    const idx = {}
    let prodId;
    let terms;
    let cpName;
    let prodName;
    let _created

    if (resp && resp.data && resp.data.pubPerformanceEntities) {
        _created = resp.data.created
        resp.data.pubPerformanceEntities.forEach(row => {
            if (row && row != null) {
                prodId = row.prodId
                prodName = row.prodName
                cpName = row.cpName
                terms = row.terms
                // sourceId = row.sourceId
                if (!idx[cpName]) {
                    idx[cpName] = {}
                }
                if (!idx[cpName][prodId]) {
                    idx[cpName][prodId] = {}
                }
                if (!idx[cpName][prodId][terms]) {
                    idx[cpName][prodId][terms] = {
                        "prodId": prodId,
                        "prodName": prodName,
                        "cpName": cpName,
                        "leads": {},
                        "amount": {},
                        "leadNew": {},
                        "approved": {},
                        "uncalled": {},
                        "rejected": {},
                        "validated": {},
                        "validatedPb": {},
                        "validatedPbPct": {},
                        "callback": {},
                        "urgent": {},
                        "avgUncalledClosedCall": 0,
                        "trash": {},
                        "name": {},
                        "cp": {},
                        "pub": {},
                        "sources": {},
                        "attempt": {}
                    }
                    idx[cpName][prodId][terms].name[terms] = prodName
                    idx[cpName][prodId][terms].cp[terms] = cpName
                    idx[cpName][prodId][terms].leads[terms] = 0
                    idx[cpName][prodId][terms].amount[terms] = 0
                    idx[cpName][prodId][terms].leadNew[terms] = 0
                    idx[cpName][prodId][terms].approved[terms] = 0
                    idx[cpName][prodId][terms].uncalled[terms] = 0
                    idx[cpName][prodId][terms].rejected[terms] = 0
                    idx[cpName][prodId][terms].validated[terms] = 0
                    idx[cpName][prodId][terms].validatedPb[terms] = 0
                    idx[cpName][prodId][terms].validatedPbPct[terms] = 0
                    idx[cpName][prodId][terms].trash[terms] = 0
                    idx[cpName][prodId][terms].callback[terms] = 0
                    idx[cpName][prodId][terms].urgent[terms] = 0
                    idx[cpName][prodId][terms].sources[terms] = []
                    idx[cpName][prodId][terms].attempt[terms] = []
                }
                idx[cpName][prodId][terms].leads[terms] += row.leads ? row.leads : 0
                idx[cpName][prodId][terms].amount[terms] += row.amount ? row.amount : 0
                idx[cpName][prodId][terms].leadNew[terms] += row.leadNew ? row.leadNew : 0
                idx[cpName][prodId][terms].approved[terms] += row.approved ? row.approved : 0
                idx[cpName][prodId][terms].uncalled[terms] += row.uncalled ? row.uncalled : 0
                idx[cpName][prodId][terms].rejected[terms] += row.rejected ? row.rejected : 0
                idx[cpName][prodId][terms].validated[terms] += row.validated ? row.validated : 0
                idx[cpName][prodId][terms].validatedPb[terms] += row.validatedPb ? row.validatedPb : 0
                idx[cpName][prodId][terms].validatedPbPct[terms] += row.validatedPbPct ? row.validatedPbPct : 0
                idx[cpName][prodId][terms].trash[terms] += row.trash ? row.trash : 0
                idx[cpName][prodId][terms].callback[terms] += row.callback ? row.callback : 0
                idx[cpName][prodId][terms].urgent[terms] += row.urgent ? row.urgent : 0
                idx[cpName][prodId][terms].avgUncalledClosedCall += row.avgUncalledClosedCall
                if(row.avgUncalledClosedCall > 0) {
                    idx[cpName][prodId][terms].attempt[terms].push(row)
                }
                idx[cpName][prodId][terms].sources[terms].push(row)
            }
        })
    }

    // Flatten the grouped data to an array
    let pubPerformanceEntities = Object.values(idx)
        .flatMap(prodMap => Object.values(prodMap)
            .flatMap(termMap => Object.values(termMap))
        );

    // Sort by leads
    pubPerformanceEntities.sort((a, b) => {
        const leadsA = Math.max(...Object.values(a.leads));
        const leadsB = Math.max(...Object.values(b.leads));
        return leadsB - leadsA;
    });

    return {
        created: _created,
        pubPerformanceEntities
    }
}

export {
    callGetStatisticReportPubPerformance
}